import React from 'react'
import { Admin, Resource, Delete } from 'admin-on-rest'
import portuguesMessages from 'aor-language-portugues'

import GasStationIcon from 'material-ui/svg-icons/maps/local-gas-station'
import OrganizationIcon from 'material-ui/svg-icons/communication/business'
import VehicleIcon from 'material-ui/svg-icons/maps/directions-car'
import UserIcon from 'material-ui/svg-icons/social/person'
import DeletedUserIcon from 'material-ui/svg-icons/action/highlight-off'
import TransactionIcon from 'material-ui/svg-icons/action/payment'
import MoneyTransferIcon from 'material-ui/svg-icons/editor/attach-money'
import DepositIcon from 'material-ui/svg-icons/editor/monetization-on'
import RoleIcon from 'material-ui/svg-icons/action/assignment-ind'
import SettingsIcon from 'material-ui/svg-icons/action/settings'

import constants from './utils/constants'
import litrozTheme from './utils/litrozTheme'
import customMessages from './utils/custom-messages-pt'
import authClient from './services/authClient'
import restClient from './services/restClient'

import { GasStationList, GasStationCreate, GasStationEdit } from './collections/gasStations'
import { OrganizationList, OrganizationCreate, OrganizationEdit } from './collections/organizations'
import { VehicleList, VehicleCreate, VehicleEdit } from './collections/vehicles'
import { UserList, DeletedUserList, UserCreate, UserEdit } from './collections/users'
import { TransactionList } from './collections/transactions'
import { MoneyTransferList } from './collections/moneyTransfers'
import { DepositList } from './collections/deposits'
import { RoleList } from './collections/roles'
import { SettingsList, SettingsCreate } from './collections/settings'

import CustomRoutes from './customRoutes'
import Menu from './menu'

const messages = {
  pt: { ...portuguesMessages, ...customMessages }
}

const App = () => (
  <Admin
    locale='pt'
    messages={messages}
    theme={litrozTheme}
    title='Litroz Admin'
    authClient={authClient}
    restClient={restClient(constants.apiUrl)}
    menu={Menu}
    customRoutes={CustomRoutes}
  >
    <Resource
      name='gasStation'
      icon={GasStationIcon}
      options={{label: 'Postos'}}
      list={GasStationList}
      create={GasStationCreate}
      edit={GasStationEdit}
      remove={Delete}
    />
    <Resource
      name='organization'
      icon={OrganizationIcon}
      options={{label: 'Empresas'}}
      list={OrganizationList}
      create={OrganizationCreate}
      edit={OrganizationEdit}
      remove={Delete}
    />
    <Resource
      name='vehicle'
      icon={VehicleIcon}
      options={{label: 'Veículos'}}
      list={VehicleList}
      create={VehicleCreate}
      edit={VehicleEdit}
      remove={Delete}
    />
    <Resource
      name='user'
      icon={UserIcon}
      options={{label: 'Usuários'}}
      list={UserList}
      create={UserCreate}
      edit={UserEdit}
      remove={Delete}
    />
    <Resource
      name='deletedUser'
      icon={DeletedUserIcon}
      options={{label: 'Usuários Excluídos'}}
      list={DeletedUserList}
    />
    <Resource
      name='transaction'
      icon={TransactionIcon}
      options={{label: 'Transações'}}
      list={TransactionList}
    />
    <Resource
      name='balanceDeposit'
      icon={DepositIcon}
      options={{label: 'Depósitos'}}
      list={DepositList}
    />
    <Resource
      name='moneyTransfer'
      icon={MoneyTransferIcon}
      options={{label: 'Pagamentos'}}
      list={MoneyTransferList}
    />
    <Resource
      name='role'
      icon={RoleIcon}
      options={{label: 'Papéis'}}
      list={RoleList}
    />
    <Resource
      name='settings'
      icon={SettingsIcon}
      options={{label: 'Configurações'}}
      list={SettingsList}
      create={SettingsCreate}
    />
  </Admin>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js